export const primary = '#3f51b5';
export const secondary = '#C46F63';
export const red = '#B00020';
export const coral = '#ffad9c';
// export const orange = '#ffca5b';
// export const green = '#55efed';
export const blue = '#5ebaff';
// export const primary = "#00254C";
// export const primary80 = "#00254C";
// export const primary60 = "#00254C";
// export const primary40 = "#00254C";
// export const primary20 = "#00254C";
// export const primary10 = "#00254C";
// export const secondary = "#EE7202";
// export const blue = "#005A7A";
export const lightblue = "#288DC0";
export const green = "#396200";
export const lightgreen = "#77BC1F";
export const purple = "277BC1F";
// export const red = "#AB0032";
export const orange = "#F9B31D";
export const yellow = "#FEE064";
